import { render, staticRenderFns } from "./Waivers.vue?vue&type=template&id=7c790030&scoped=true"
import script from "./Waivers.vue?vue&type=script&lang=js"
export * from "./Waivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c790030",
  null
  
)

export default component.exports